<template>

<div>
  <label class="container">
    <img src="../assets/checked.svg" @click="handleClick" v-if="state.checked" >
    <img src="../assets/unchecked.svg" @click="handleClick" v-if="!state.checked"  />
  </label>
</div>

</template>
<script>
import { reactive, watch } from '@vue/composition-api'

export default {
    name: "Checkbox",
    props: ['onChecked', 'id', 'rowSelected'],
    setup(props) {
        const state = reactive({
          checked: props.rowSelected.includes(props.id) || false,
          id: props.id
        })
        const handleClick = (e) => {
           state.checked = !state.checked
           props.onChecked({value: state.checked, id: props.id})
        }

      watch(() =>  props.rowSelected, (value) => {
        state.checked = props.rowSelected.includes(props.id);
      })
      watch(() =>  props.id, (value) => {
        state.checked = props.rowSelected.includes(props.id);
      })

        return {
            handleClick,
            state
        }
    }
}
</script>
<style lang="scss" scoped>
/* Customize the label (the container) */
.container {
  position: relative;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  label {
        display: none;
        width: 15px;
        padding: 0;
  }
}

/* Hide the browser's default checkbox */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
  display: none;
}



/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: -8px;
  height: 15px;
  width: 15px;
  background-color: #fff;
  border: 2px solid #B8B8B8;
}

/* On mouse-over, add a grey background color */

/* When the checkbox is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: #67D495;
  border: none;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.container .checkmark:after {
  left: 4px;
  top: 2px;
  width: 6px;
  height: 9px;
  font-weight: 300;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

</style>
